import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Form } from 'react-bootstrap';

import { Table, IndexTableContextMenu, WinRedInput } from 'modules/common';
import { CommitteeComponent } from '../committee.component';
import { replaceSpacesWithDashes, urlSlugValidator } from 'core/utilities';

export const TemplateTableDesktop = ({ items, dropdownAction, onCheck, selectedTemplates, onChange }) => {
  const tableBody = items.map((item, index) => {
    const { id, name, slug, upsell_agency_fees_enabled, recurring_agency_fees_enabled, source_code } = item;
    const isSelected = selectedTemplates.includes(id);
    const handleOnCheck = ({ target: { checked } }) => {
      onCheck(checked, id);
    };
    const onChangeSlug = ({ target: { name, value } }) => {
      handleOnChange({ target: { name, value: replaceSpacesWithDashes(value) } });
    };
    const handleOnChange = ({ target: { name, value } }) => {
      onChange(id, name, value);
    };

    return (
      <Fragment key={item.id}>
        <Table.Row key={index} className="p-0" role="link" tabIndex="0">
          <Table.Cell className="align-top">
            <Form.Check type="checkbox" checked={isSelected} onChange={handleOnCheck} />
          </Table.Cell>
          <Table.Cell className="align-top">
            <div className="flex flex-col justify-center">
              {item?.partnership_templates?.length > 0
                ? item?.partnership_templates.map(committee => {
                    return <CommitteeComponent item={committee} key={committee.id} />;
                  })
                : null}
            </div>
          </Table.Cell>
          <Table.Cell className="align-top">
            <WinRedInput
              name="name"
              placeholder="Internal Page Name"
              className="mb-2"
              type="text"
              validators={
                isSelected && [
                  { message: 'Internal Page Name is required', validator: 'required' },
                  {
                    message: 'Internal Page Name cannot be over 140 characters',
                    validator: pageName => pageName.length <= 140,
                  },
                ]
              }
              value={name}
              onChange={handleOnChange}
            />
            <WinRedInput
              name="slug"
              placeholder="URL Slug"
              type="text"
              className="mb-2"
              validators={
                isSelected && [
                  { message: 'URL Slug is required', validator: 'required' },
                  {
                    message: 'URL slug can only contain lowercase letters, numbers, dashes and underscores.',
                    validator: urlSlugValidator,
                  },
                  { message: 'URL Slug cannot be over 50 characters', validator: slug => slug.length <= 50 },
                ]
              }
              value={slug}
              onChange={onChangeSlug}
            />
            <WinRedInput
              name="source_code"
              placeholder="Source Code"
              type="text"
              value={source_code}
              onChange={handleOnChange}
            />
          </Table.Cell>
          <Table.Cell className="align-top">
            {upsell_agency_fees_enabled ? (
              <div className="bg-purple-light text-purple-dark border-purple-dark label-status px-3 py-1 font-medium rounded-full inline-block text-center mr-2">
                Upsell
              </div>
            ) : null}
            {recurring_agency_fees_enabled ? (
              <div className="bg-purple-light text-purple-dark border-purple-dark label-status px-3 py-1 font-medium rounded-full inline-block text-center">
                Subscription
              </div>
            ) : null}
          </Table.Cell>
          <Table.Cell className="align-top" textAlign="center" noClick>
            <IndexTableContextMenu onSelect={eventKey => dropdownAction(eventKey, item)}>
              <Dropdown.Item eventKey="edit">Edit</Dropdown.Item>
              <Dropdown.Item eventKey="delete">Delete</Dropdown.Item>
            </IndexTableContextMenu>
          </Table.Cell>
        </Table.Row>
      </Fragment>
    );
  });

  return (
    <Table data-testid="my-pages-index" className="pages-index-desktop">
      <Table.Body className="pointer">{tableBody}</Table.Body>
    </Table>
  );
};

TemplateTableDesktop.propTypes = {
  items: PropTypes.array.isRequired,
  dropdownAction: PropTypes.func.isRequired,
  onCheck: PropTypes.func.isRequired,
  selectedTemplates: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TemplateTableDesktop;
